import React, { createContext, ReactNode, useContext } from 'react'

/**
 * Which inbox the inbox tree is rendering.
 *
 *  - personal: the signed-in user's own LinkedIn, read and sent through the browser extension
 *  - shared:   the workspace's proxy (Unipile) accounts, read and sent through the API — no
 *              extension involved, and every thread belongs to one of several accounts
 *
 * The same components serve both; the few places that differ (data source, actions LinkedIn
 * only allows on your own account) branch on this.
 */
export type TInboxMode = 'personal' | 'shared'

const InboxModeContext = createContext<TInboxMode>('personal')

export const InboxModeProvider = ({ mode, children }: { mode: TInboxMode; children?: ReactNode }) => (
    <InboxModeContext.Provider value={mode}>{children}</InboxModeContext.Provider>
)

export const useInboxMode = () => useContext(InboxModeContext)

export const useIsSharedInbox = () => useContext(InboxModeContext) === 'shared'
